import { Dispatch } from 'redux';
import { MockApiHandler } from '../../mock-api/mock-api-model';
import { PersonSearchPayload } from '../../pages/arc/features/person-search/person-search-model';
import { ApiEndpoint } from '../constants/api-endpoints';
import { addQueryParams } from '../helpers/url-helper';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';


export const setPersonWithHandler = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.personPrc}/${guid}`,
		onSuccess,
		onFailure,
	});
};

export const getSpouses = (guid: string, current: boolean, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/spouse/spouseType/${current ? 'current' : 'all'}`,
		onSuccess,
		onFailure,
	});
};

export const patchPersonInfo = (guid: string, payload, adminMode = false, onSuccess?: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return adminMode ?
		apiAction({
			method: HttpMethods.PATCH,
			url: `${ApiEndpoint.personPrcAdmin}/${guid}`,
			payloadData: payload,
			onSuccess,
			onFailure,
		}) :
		apiAction({
			method: HttpMethods.PATCH,
			url: `${ApiEndpoint.personPrc}/${guid}`,
			payloadData: payload,
			onSuccess,
			onFailure,
		});
};


export const patchPublishMailingAddress = (guid: string, onSuccess?: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {

	const payloadData = {
		source: 'mailing',
		destination: 'published',
	};

	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.personPrc}/${guid}/copyAddress`,
		payloadData,
		onSuccess,
		onFailure,
	});
};

export const postSpouse = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/spouse`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const putSpouse = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PUT,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/spouse`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const patchSpouse = (guid: string, startDate: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/spouse/${startDate}`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const patchDivorce = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.personPrc}/${guid}/divorce`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const patchLegallySeparation = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/spouse/${payload?.start_date}`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const patchDeath = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.personPrc}/${guid}/death`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const getChildren = (guid: string, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/child`,
		onSuccess,
		onFailure,
	});
};

export const postChild = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/child`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const putChild = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PUT,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/child`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const patchChild = (guid: string, childId: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/child/${childId}`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};


export const getEmploymentHistoryWithHandler = (guid: string, onSuccess: (response, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.personPrc}/employee/${guid}/employments`,
		onSuccess,
		onFailure,
	});
};

export const getDomesticPartners = (guid: string, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/domesticPartners/domesticPartnerType/all`,
		onSuccess,
		onFailure,
	});
};

export const postDomesticPartner = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/domesticPartners`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const putDomesticPartner = (guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PUT,
		url: `${ApiEndpoint.personPrc}/${guid}/dependents/domesticPartners`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const patchDomesticPartner = (personGuid: string, guid: string, payload, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.personPrc}/${personGuid}/dependents/domesticPartners/${guid}`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};


export interface GetMatchParams {
	firstName?: string;
	lastName?: string;
	taxId?: string;
	dob?: string;
	fullName?: string;
	elecAddr?: string;
	phNumber?: string;
	addrLine1?: string;
	zipCode?: string;
	country?: string;
	partyId1RelCode?: string;
	limit?: number;
	orderBy?: string;
	totalResults?: boolean;
}
export const getMatch = (queryParams: GetMatchParams, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: addQueryParams(`${ApiEndpoint.personPrc}/getMatch`, queryParams),
		onSuccess,
		onFailure,
	});
};

export const personSearch = (payload: PersonSearchPayload, officers: boolean = false, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.personPrc}/search/${officers ? 'officers' : 'non_officers'}`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const postEmployee = (payload: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.personPrc}/employee`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const putEmployment = (payload: any, guid: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PUT,
		url: `${ApiEndpoint.personPrc}/employee/${guid}/employments`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const getDocumentsToDownload = (clientId: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.personPrc}/${clientId}/documents?source=ALFRESCO&node_type=cpd`,
		onSuccess,
		onFailure,
	});
};

export const postNewEmployment = (payload: any, guid: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.benAdmin}/employees/${guid}/employments.json`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const patchTermination = (
	payload: any,
	guid: string,
	onSuccess: (response) => any,
	onFailure?: (dispatch?: Dispatch<any>) => any,
	mockApiHandler?: MockApiHandler,
): ApiAction => {
	return apiAction({
		method: HttpMethods.PATCH,
		url: `${ApiEndpoint.personPrc}/employee/${guid}/employment/terminations`,
		payloadData: payload,
		onSuccess,
		onFailure,
		mockApiHandler,
	});

};

export const getPersonBenefitSurveyData = (guid: string, clientGuid: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.personPrc}/${guid}/benefitsSurvey/${clientGuid}`,
		onSuccess,
		onFailure,
	});
};

export const updatePersonBenefitSurveyData = (guid: string, payload: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.PUT,
		url: `${ApiEndpoint.personPrc}/${guid}/benefitsSurvey`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const getMyDocuments = (clientId: string, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.GET,
		url: `${ApiEndpoint.personPrc}/${clientId}/documents/terminations?source=ALFRESCO`,
		onSuccess,
		onFailure,
	});
};

export const getIsReceivingPensionOrPayout = (clientId: string, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		url: `${ApiEndpoint.personPrc}/${clientId}/pension`,
		onSuccess,
		onFailure,
	});
};

export const postNewPerson = (payload: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: ApiEndpoint.personPrc,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};

export const postOptIn = (payload: any, onSuccess: (response) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.wam}/contact_preferences/opt_in`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};